import { createControlComponent } from "@react-leaflet/core";
import "leaflet-routing-machine";
import L from "leaflet";
// import { Routing } from "leaflet";
import {Geocoder} from 'leaflet-control-geocoder';
// import { useMap } from "react-leaflet";
// import { withLeaflet } from "react-leaflet";
// import { MapLayer } from "react-leaflet";


const RoutingMachine = createControlComponent(props => {
    
    let instance = L.Routing.control({
        waypoints: props.waypoints,
        lineOptions: {
            styles: [{ color: props.color}]
        }, 
        show:false,
        
        collapsible:false,
        draggableWaypoints: false,
        routeWhileDragging: false,
        showAlternatives: false
        // createInstructions
        // show: true,
        /*  addWaypoints: false, 
        routeWhileDragging: true,
        draggableWaypoints: false,
        fitSelectedRoutes: false,
        showAlternatives: false  */
        
        
      });
      // Obtener puntos intermedios
      const waypoints = instance.getWaypoints();
      // console.log('way: ',waypoints);
    
  
    return instance;
  });

export default RoutingMachine;





/* const createRoutineMachineLayer = (props) => {
    const instance = L.Routing.control({
      waypoints: [
        L.latLng(50.840516, 4.3601411),
        L.latLng(50.85521199999999, 4.3604002)
      ],
      lineOptions: {
        styles: [{ color: "blue", weight: 4 }]
      }, 
       show: false,
      addWaypoints: false, 
      routeWhileDragging: true,
      draggableWaypoints: false,
      fitSelectedRoutes: false,
      showAlternatives: false 
    });
    return instance;
  };
  const RoutingMachine = createControlComponent(createRoutineMachineLayer);
  export default RoutingMachine; */




